export const GOOGLE_WEB_BUTTON_CONTAINER = 'google-web-button-container'
